import React, { useState, useEffect } from "react";
import ExpandableWithToggle from "../../../../components/BasicComponents/ExpandableWithToggle";

export default function SingleValueList({
  columnName,
  selectedFilterValues,
  setSelectedFilters,
  dispatchUpdateItem,
  allOptions,
}) {
  // console.log(selectedFilterValues);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValue, setSelectedValue] = useState(selectedFilterValues);

  useEffect(() => {
    setSelectedFilters(selectedValue);
  }, [selectedFilterValues]);

  const handleItemClick = (value) => {
    if (value === selectedValue) {
      setSelectedValue(null);
      setSelectedFilters(null);
      dispatchUpdateItem([]);
    } else {
      setSelectedValue(value);
      setSelectedFilters(value);
      dispatchUpdateItem([value]);
    }
  };

  const handleTextInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredOptions = allOptions.filter((option) => {
    if (typeof option === "string") {
      return option.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (typeof option === "number") {
      return option.toString().toLowerCase().includes(searchTerm.toLowerCase());
    }
    return false;
  });

  return (
    <main className="px-1 py-1 flex flex-col overflow-y-auto w-full">
      <ExpandableWithToggle
        componentType={"ASIDE3FILTERS"}
        aside3Title={`(${selectedValue || ""})`}
      >
        <section className="w-full flex flex-col gap-1 shadow items-center justify-start rounded p-2 border-[1px]">
          <div className="flex items-center justify-center w-full">
            {/* <FaSearch className="text-gray-300" /> */}
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleTextInputChange}
              className="px-2 border rounded text-base h-7 w-full focus:outline-none font-light"
            />
          </div>
          <div
            className={`w-full ${
              filteredOptions.length <= 4 ? "h-auto" : "h-[7rem]"
            } overflow-y-auto`}
          >
            {filteredOptions.map((option, index) => (
              <button
                key={index}
                className={`text-black p-[2px] w-full font-light text-left whitespace-nowrap relative flex items-center rounded text-sm ${
                  option === selectedValue ? "bg-gray-200" : ""
                }`}
                onClick={() => handleItemClick(option)}
              >
                {option}
              </button>
            ))}
          </div>
        </section>
      </ExpandableWithToggle>
    </main>
  );
}
